module.exports = __webpack_public_path__ + "img/icons8-cat-footprint-100.606f64c1.png";